@if (item.url && !item.external) {
  <li [ngClass]="item.classes!" [routerLinkActive]="['active']">
    <a [target]="item.target ? '_blank' : '_self'" [routerLink]="[item.url]" (click)="closeOtherMenu($event)" [attr.title]="isCollapsed() ? item.title : null">
      @if (item.icon) {
        <span class="coded-micon">
          @if (item.fontIcon) {
            <i [class]="item.icon"></i>
          } @else {
            <!-- <i antIcon [type]="item.icon" theme="outline"></i> -->
            <app-icon [name]="item.icon"></app-icon>
          }
        </span>
      }
      @if (item.icon) {
        <span class="coded-mtext">{{ item.title }}</span>
      } @else {
        {{ item.title }}
      }
    </a>
  </li>
}
@if (item.url && item.external) {
  <li [ngClass]="item.classes!">
    <a [target]="item.target ? '_blank' : '_self'" [href]="item.url" [attr.title]="isCollapsed() ? item.title : null">
      @if (item.icon) {
        <span class="coded-micon">
          @if (item.fontIcon) {
            <i [class]="item.icon"></i>
          } @else {
            <app-icon [name]="item.icon"></app-icon>
          }
        </span>
      }
      @if (item.icon) {
        <span class="coded-mtext">{{ item.title }}</span>
      } @else {
        {{ item.title }}
      }
    </a>
  </li>
}
